/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Vue } from 'vue-property-decorator';

/* ----------------------------------------
    Modules
---------------------------------------- */

import merge from 'lodash/merge';
import * as moment from 'moment';

/* ----------------------------------------
     Module Helper
 ---------------------------------------- */

import { StoreModule } from "@store/service/Modules";

const module = new StoreModule('general');
const template = new StoreModule('templates');

/* ----------------------------------------
     Helpers
 ---------------------------------------- */

import { loader } from '@util/images';

/* ----------------------------------------
     Helpers
 ---------------------------------------- */

const suffixName = (number, lang) => {
    if(lang === 'eng') {
        const suffix = ['th', 'st', 'nd', 'rd'];
        let modulo = number % 100;
        return number + (suffix[(modulo - 20) % 10] || suffix[modulo] || suffix[0]);
    }

    return number;
};

const capitalizeFirst = string => {
    return string.charAt(0).toUpperCase() + string.slice(1);
};

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({

    computed: {
        address() {
            return module.getters('getContactInformation', 'address');
        },

        call() {
            return module.getters('getContactInformation', 'call');
        },

        connect() {
            return module.getters('getContactInformation', 'connect');
        },

        init() {
            return module.getters('getInit');
        },

        logos() {
            return module.getters('getLogos');
        },

        lang() {
            return module.getters('getLanguage')
        },

        mail() {
            return module.getters('getContactInformation', 'mail');
        },

        menu() {
            return module.getters('getMenu');
        },

        socials() {
            return module.getters('getContactInformation', 'socials');
        },

        translations() {
            return module.getters('getTranslation');
        },
    },

    methods: {
        date: function(date) {
            const local = this.lang === 'eng' ? 'en' : 'nl';
            const time = moment(date).locale(local);

            return {
                day: suffixName(time.format('D'), this.lang),
                month: time.format('MM'),
                year: time.format('YYYY'),
                dayName: capitalizeFirst(time.format('dddd')),
                monthName: capitalizeFirst(time.format('MMMM'))
            };
        },

        iconName: string => {
            if (typeof string !== 'string') return '';
            const name = string.charAt(0).toUpperCase() + string.slice(1);
            return name + 'Icon'
        },

        popupCall: function(e) {
            e.preventDefault();
            this.$root.$emit('popup-call');
        },

        loadImages: array => {
            const loading = loader(array);

            loading.then(data => {
                console.log('resolved', data);
            })
        },

        translate: function(select) {
            const values = select.split('.').reduce((o,i) => o[i], this.translations);
            return values[this.lang];
        },

        template(name, additional = {}) {
            const data = template.getters('getTemplate', name);
            return merge(data, additional);
        },

        toggleLang: function(e) {
            e.preventDefault();
            const current = module.getters('getLanguage');
            const lang = current === 'eng' ? 'nl' : 'eng';
            module.actions('setLang', lang);
        }
    }

})

/* ----------------------------------------
    Export
---------------------------------------- */

export class GeneralMixin extends Vue {}